import { updateSearch } from 'bernie-core';
export const isALinkAction = action => {
  var _a;
  return (action === null || action === void 0 ? void 0 : action.analytics) && ((_a = action.resource) === null || _a === void 0 ? void 0 : _a.relativePath);
};
export const handleLinkActionFromErrorMessage = (action, analytics, searchResults, history, location) => {
  if (isALinkAction(action)) {
    const linkAction = action;
    const {
      referrerId
    } = linkAction.analytics;
    const message = 'MultiItem Error';
    const hotelsSearchURL = linkAction.resource.relativePath;
    if (analytics && typeof analytics.trackEvent === 'function') {
      analytics.trackEvent(referrerId, message, null, null, true);
    }
    window.location.replace(hotelsSearchURL);
  } else {
    handleRetry(':errorOnSearch', 'MultiItem Retry Search', analytics, searchResults, history, location);
  }
};
export const handleRetry = (rfrr, message, analytics, searchResults, history, location) => {
  if (analytics && typeof analytics.trackEvent === 'function') {
    analytics.trackEvent(rfrr, message, null, null, true);
  }
  if (searchResults) {
    searchResults.shouldFetch = true;
  }
  updateSearch({
    history,
    location,
    newParams: {}
  });
};